import { FC } from 'react';

export const NotoSansPreload: FC = () => (
  <>
    <div style={{
      fontFamily: 'Noto Sans',
      fontWeight: 300,
      visibility: 'hidden',
      height: '0'
    }}>Noto Sans 300 Preload</div>
    <div style={{
      fontFamily: 'Noto Sans',
      fontWeight: 500,
      visibility: 'hidden',
      height: '0'
    }}>Noto Sans 500 Preload</div>
    <div style={{
      fontFamily: 'Noto Sans',
      fontWeight: 600,
      visibility: 'hidden',
      height: '0'
    }}>Noto Sans 600 Preload</div>
  </>
);
